import {api, apiClient} from '@/shared/services/api-client';

export interface ProjectTeamQuery {
  role?: string;
  status?: string;
}

export const projectsApi = {
  listProjects: () => api.projects.list(),
  getProject: (id: string) => api.projects.get(id),
  getProjectRole: (id: string) => api.projects.getRole(id),
  getProjectRolesBatch: (projectIds: string[]) => api.projects.getRolesBatch(projectIds),
  createProject: (data: any) => api.projects.create(data),
  updateProject: (id: string, data: any) => api.projects.update(id, data),
  deleteProject: (id: string) => api.projects.delete(id),
  activateProject: (id: string) => api.projects.activate(id),
  completeProject: (id: string) => api.projects.complete(id),

  listProjectModerators: (params?: {project_id?: string; limit?: number}) =>
    api.projectModerators.list(params),
  createProjectModerator: (data: any) => api.projectModerators.create(data),
  updateProjectModerator: (id: string, data: any) =>
    api.projectModerators.update(id, data),
  deleteProjectModerator: (id: string) => api.projectModerators.delete(id),

  getProjectTeam: (projectId: string, params?: ProjectTeamQuery) =>
    api.team.getByProject(projectId, params),
  getProjectTeamStats: (projectId: string) => api.team.getStats(projectId),
  getProjectSchedulers: (projectId?: string) => api.team.getSchedulers(projectId),
  addProjectMember: (projectId: string, data: any) => api.team.addMember(projectId, data),
  updateProjectMember: (memberId: string, data: any) =>
    api.team.updateMember(memberId, data),
  removeProjectMember: (memberId: string) => api.team.removeMember(memberId),
  getProjectAvailableUsers: (projectId: string, search = '') =>
    api.team.getAvailableUsers(projectId, search),
  acceptTeamInvitation: (token: string) => api.team.acceptInvitation(token),
  inviteProjectMembers: (projectId: string, data: {emails: string[]; role: string}) =>
    apiClient.post(`/team/project/${projectId}/invitations`, data),
  resendMemberInvite: (memberId: string) =>
    apiClient.post(`/team/members/${memberId}/resend-invite`),
};
